import { Settings } from "@/components/ui/SettingsSection";
import { Button } from "@/components/ui/button";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { OrganizationDeleteModal } from "./OrganizationDeleteModal";

export function OrganizationDelete() {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  return (
    <>
      <Settings.Section title="Delete organization">
        <Settings.Item
          title="Delete organization"
          description="Delete your organization. This action cannot be undone."
        >
          <Button
            className="w-fit"
            variant="destructive"
            onClick={() => setOpenDeleteModal((p) => !p)}
          >
            Delete organization
          </Button>
        </Settings.Item>
      </Settings.Section>
      <AnimatePresence>
        {openDeleteModal && (
          <OrganizationDeleteModal setOpen={setOpenDeleteModal} />
        )}
      </AnimatePresence>
    </>
  );
}
